import React, { FC, HTMLAttributes, useState } from 'react';
import UserMenuButton from './UserMenuButton';
import UserMenuPopup from './UserMenuPopup';
import { styled } from '@material-ui/core';

const UserMenuWrapper = styled('div')({
  position: 'relative',
  display: 'flex',
  alignSelf: 'stretch',
});

const UserMenu: FC<HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <UserMenuWrapper {...rest}>
        <UserMenuButton open={open} onClick={() => setOpen(!open)} />
        {open && <UserMenuPopup onClose={() => setOpen(false)} />}
      </UserMenuWrapper>
    </>
  );
};

export default UserMenu;
